import styled from 'styled-components';

export const FormError = styled.div`
  color: ${({theme}) => theme.colors.palettes.red[70][100]};
  font-size: ${({theme}) => theme.fontSizes.text.xxSmall};
  text-align: left;
  line-height: 1.4;
  margin-top: 4px;
`;
